/* reducer is used in client area */
import {
    USER_LOGOUT, FETCH_ADMIN_PRODUCTS,ADD_SELECTED_PRODUCTS,REMOVE_SELECTED_PRODUCTS,CLEAR_SELECTED_PRODUCTS,
    FETCH_ADMIN_PRODUCT,UPDATE_ADMIN_PRODUCT_IMAGE,UPDATE_ADMIN_PRODUCT_IMAGES,
    DELETE_ADMIN_PRODUCT,
    DELETE_ADMIN_PRODUCT_IMAGE,UPDATE_ADMIN_PRODUCT,UPLOAD_ADMIN_PRODUCT_IMAGE }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [],fetched:false, total:0,selectedProducts:[]};
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ADMIN_PRODUCTS:
          //console.log(`FETCH_ADMIN_PRODUCTS${action.payload}`);

            return {
                ...state,
                data: action.payload.data,
                total: _.isUndefined(_.get(action.payload,'total')) ? _.size(action.payload.data) :action.payload.total, /* action.payload.total can be undefined when all parameter is passed*/
                fetched:true,
            }
        case FETCH_ADMIN_PRODUCT:
            console.log("FETCH_ADMIN_PRODUCT$", action.payload);
            var productIndex =_.findIndex(state.data, {_id:action.payload._id})
            var dataToUpdate =[]
            if(productIndex == -1){
                dataToUpdate = state.data.concat([action.payload])
            }else{
                dataToUpdate = [...state.data.slice(0, productIndex),
                    action.payload,
                    ...state.data.slice(productIndex + 1)];
            }
            return {
                ...state,
                data: dataToUpdate,
                total: 1
            }
        case ADD_SELECTED_PRODUCTS:
         //   console.log('ADD_SELECTED_PRODUCTS', state,  action.payload);
            var selectedProductsToAdd =_.map( action.payload, function (product) {
                return product._id;
            });
            var updatedSelectedProducts = _.uniq(state.selectedProducts.concat(selectedProductsToAdd));
            return {
                ...state,
                selectedProducts: updatedSelectedProducts
            }
        case CLEAR_SELECTED_PRODUCTS:
            console.log('CLEAR_SELECTED_PRODUCTS', state,  action.payload);
            return {
                ...state,
                selectedProducts: []
            }
        case REMOVE_SELECTED_PRODUCTS:
            console.log('REMOVE_SELECTED_PRODUCTS', state,  action.payload);
            var selectedProductsToRemove =_.map( action.payload, function (product) {
               return product._id;
            });
             var updatedSelectedProducts =  _.uniq(_.difference(state.selectedProducts, selectedProductsToRemove));
            console.log('updatedSelectedProducts', updatedSelectedProducts);

            return {
                ...state,
                selectedProducts: updatedSelectedProducts,
            }
        case UPDATE_ADMIN_PRODUCT:
            console.log('UPDATE_ADMIN_PRODUCT', state,  action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload._id});

            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                action.payload,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }
        case DELETE_ADMIN_PRODUCT:
            console.log('DELETE_ADMIN_PRODUCT', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.productID});
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                total:state.total-1,
                data: updatedProducts
            }
        case UPLOAD_ADMIN_PRODUCT_IMAGE:
            console.log('UPLOAD_ADMIN_PRODUCT_IMAGE', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.productID});

            var updatedProduct = {
                ...state.data[itemProductIndex],
                OriginalImages: _.concat(state.data[itemProductIndex].OriginalImages, [action.payload])
            }
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                updatedProduct,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }
        case DELETE_ADMIN_PRODUCT_IMAGE:
            console.log('DELETE_ADMIN_PRODUCT_IMAGE', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.productID});
            var productImageIndex = _.findIndex(state.data[itemProductIndex].OriginalImages, {'_id': action.payload.imageID});

            var updatedProduct = {
                ...state.data[itemProductIndex],
                OriginalImages: [...state.data[itemProductIndex].OriginalImages.slice(0, productImageIndex),
                    ...state.data[itemProductIndex].OriginalImages.slice(productImageIndex + 1)]
            }
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                updatedProduct,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }
        case UPDATE_ADMIN_PRODUCT_IMAGE:
            console.log('UPDATE_ADMIN_PRODUCT_IMAGE', action.payload);
            var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.productID});
            var productImageIndex = _.findIndex(state.data[itemProductIndex].OriginalImages, {'_id': action.payload._id});

            var updatedProduct = {
                ...state.data[itemProductIndex],
                OriginalImages: [...state.data[itemProductIndex].OriginalImages.slice(0, productImageIndex),
                    action.payload,
                    ...state.data[itemProductIndex].OriginalImages.slice(productImageIndex + 1)]
            }
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                updatedProduct,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }
        case UPDATE_ADMIN_PRODUCT_IMAGES:
            console.log('UPDATE_ADMIN_PRODUCT_IMAGES', action.payload);
             var itemProductIndex = _.findIndex(state.data, {'_id': action.payload.productID});
            var updatedProduct = {
            ...state.data[itemProductIndex],
            OriginalImages:action.payload.data
        }
            var updatedProducts = [...state.data.slice(0, itemProductIndex),
                updatedProduct,
                ...state.data.slice(itemProductIndex + 1)];
            return {
                ...state,
                data: updatedProducts
            }


        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}

export const getProduct = (state, id) => {
     return state.adminProducts.data.filter(record => record._id === id)[0];
}